import { stringify } from 'query-string';
import { PB_QUERY_CONST, PAGINATION_QUERY_CONST } from '../../../constants';

const buildPaginationUrl = (name, page, query, url) => {
  const newQuery = { ...query, [`${PB_QUERY_CONST}[${name}]${PAGINATION_QUERY_CONST}`]: page };
  const stringQuery = stringify(newQuery);
  return `${url}?${stringQuery}`;
};

export default buildPaginationUrl;
